module.exports = __webpack_public_path__ + "static/img/paco.ea801f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paco.jpg
// module id = LK+y
// module chunks = 0